import React from 'react';
import { Config } from '@leverege/plugin';
import { EditorUtil, Variantizers } from '@leverege/ui-attributes';
import { System } from '@leverege/api-redux';
import { BlueprintDataSource } from '@leverege/molten-core';
import EnumSelector from "../EnumSelector.js";
import Util from "../Util.js";
import { jsx as _jsx } from "react/jsx-runtime";
const EMPTY = {};
const opts = {
  table: {
    isRenderer: true,
    embed: true
  }
};
export default {
  valueType: 'resourceEnum',
  getOptions: usage => {
    return Config.get('ResourceEnumEditor', usage, opts[usage]);
  },
  create: opts => {
    const {
      usage,
      attribute,
      object,
      onChange,
      value,
      editable,
      eventData,
      context
    } = opts;
    const {
      relationship
    } = BlueprintDataSource.getRelationship(object) || EMPTY;
    const resourceEnumType = attribute?.blueprint?.attribute?.model?.enumType;
    const getEnumData = state => System(relationship.systemId).resourceEnum(resourceEnumType).getResourceEnum(state);
    const variant = Util.getAttributeRendererValueVariant(context?.renderer);
    const textVariant = Variantizers.getVariant(variant, object, context);
    return /*#__PURE__*/_jsx(EnumSelector, {
      textVariant: textVariant,
      editable: editable,
      usage: usage,
      attribute: attribute,
      onChange: onChange,
      relationship: relationship,
      eventData: eventData,
      getEnumData: getEnumData,
      variant: EditorUtil.getVariant(usage, 'resourceEnum', 'editor'),
      toggleVariant: EditorUtil.getVariant(usage, 'resourceEnum', 'editor'),
      value: value
    });
  }
};